import { forOwn } from 'lodash';

import { InterestsIdsType } from '../../components/InterestsSetEditor/InterestsSetEditor';
import { CryptaSegment } from '../../typings/cryptaSegments';

export const getSegmentsIds = (interests: CryptaSegment[]): InterestsIdsType => {
    const ids = {};

    interests.forEach(interest => {
        ids[interest.id] = {
            name: interest.name,
            parentId: interest.parentId
        };
    });

    return ids;
};

export const getSegmentsTree = (interests: CryptaSegment[]): Record<number, CryptaSegment[]> => {
    if (!interests.length) {
        return {};
    }

    const groups = {};

    interests.forEach(interest => {
        const parentId = interest.parentId;

        if (!parentId) {
            throw new Error('interest segments without parent');
        }

        if (!groups[parentId]) {
            groups[parentId] = [];
        }

        groups[parentId].push(interest);
    });

    // сортировка по алфавиту
    forOwn(groups, (group: CryptaSegment[]) => {
        group.sort((a, b) => a.name.localeCompare(b.name));
    });

    return groups;
};

export const getOpenedList = (checkedList: string[], interestsIds: InterestsIdsType): string[] => {
    const openedList: string[] = [];
    const addItemInOpenedList = (id: string): void => {
        const parentId = interestsIds[id] && interestsIds[id].parentId;

        openedList.push(id);

        return parentId && parentId !== '0' && !openedList.includes(parentId)
            ? addItemInOpenedList(parentId)
            : undefined;
    };

    checkedList.forEach(id => {
        return interestsIds[id] && interestsIds[id].parentId !== '0' ? addItemInOpenedList(id) : undefined;
    });

    return openedList;
};
